import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import MinidumpSwitch from 'svg/v2/newcs_dashboard_crashanalysis_issuedetail_minidump_switch_normal.svg';

import style from './CsSwapSelect.scss'

const CsSwapSelect = ({
  options: nullableOptions,
  disabled,
  value,
  onClick,
  onChange,
  type: nullableType,
}) => {
  const options = nullableOptions || [];
  const type = nullableType ?? 'default'

  const currentMatchedOptionIndex = useMemo(() => {
    return options.findIndex(x => x.value === value);
  }, [options, value]);

  const currentMatchedOption = options[currentMatchedOptionIndex];

  const defaultDom = <div
    className={`${style.default_box} ${disabled ? style.disabled : ''}`}
    onClick={(e) => {
      onClick && onClick();
      if (disabled) {
        return;
      }
      if (!onChange || options.length === 0) {
        return;
      }
      const newIndex = (currentMatchedOptionIndex + 1) % options.length;
      onChange(options[newIndex]?.value);
    }}
  >
    <div>{ currentMatchedOption?.label || currentMatchedOption?.value }</div>
    <span className={`${style.MinidumpSwitch} ${disabled ? style.disabled : ''}`}><MinidumpSwitch /></span>
  </div>;

  const primaryDom = <div
    className={`${style.primary_box} ${type === 'small' ? style.primary_box_small : ''} ${disabled ? style.disabled : ''}`}
    onClick={(e) => {
      onClick && onClick();
      if (disabled) {
        return;
      }
      if (!onChange || options.length === 0) {
        return;
      }
      const newIndex = (currentMatchedOptionIndex + 1) % options.length;
      onChange(options[newIndex]?.value);
    }}
  >
    <div>{currentMatchedOption?.label || currentMatchedOption?.value}</div>
    <span className={`${style.MinidumpSwitch} ${disabled ? style.disabled : ''}`}><MinidumpSwitch /></span>
  </div>;

  const domMap = {
    'default': defaultDom,
    'primary': primaryDom,
    'small': primaryDom,
  }

  return domMap[type];
};

export default CsSwapSelect;
